export enum SidebarMenu {
  PROFILE = "profile",
}

export type Record = {
  title: string;
  date: string;
  sessionId: string;
  task_schedule?: null | { id: string; status: string };
  lastest_message_id?: number;
  last_read_message_id?: number;
  has_unread_messages?: boolean;
};

export type PaginatedChatsResponse = {
  pages: PaginatedRecords[];
  pageParams?: [];
};

export type PaginatedRecords = {
  records: Record[];
  pagination: {
    perPage: number;
    currentPage: number;
    totalPages: number;
    totalCount: number;
  };
};

export enum AuthActions {
  SIGNIN = "signin",
  SIGNUP = "signup",
}
